import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
    Container,
    Box,
    Typography,
    Paper,
    Button,
    Snackbar,
    Alert,
    Grid,
    TextField,
    Backdrop,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import { BsArrowRight } from "react-icons/bs";
import {  investorApi } from "../../api/api"; // Assuming your API functions are in this file
import { values } from "@babel/runtime/regenerator";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


const NewTeam = () => {
    const [loading, setLoading] = useState(false); // Loader state
    const [snackbarOpen, setSnackbarOpen] = useState(false); 
    const [snackbarMessage, setSnackbarMessage] = useState(""); 
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); 
    const [memberName, setMemberName] = useState("");
    const [experience, setExperience] = useState("");
    const [description, setDescription] = useState("");
    const [files, setFiles] = useState([]); // Only allow one image
    const [selectedImage, setSelectedImage] = useState(null); // Store file
    const [ImagePreview, setImagePreview] = useState(null);
    const [propertyErrors, setPropertyErrors] = useState({});
    const [contactnumber,setContactNumber]= useState("");
    const [email,setEmail]=useState("");
    const [status,setStatus]=useState(""); 
    const user=useSelector((state)=>state.user.userId);
    const navigate=useNavigate();

    const handleDisplayImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file); // Store the actual file for uploading
            setImagePreview(URL.createObjectURL(file));
        }
    };

   const statusOptions=[
        {label:"Active", value:"Active"},
        {label:"InActive",value:"InActive"}
    ]
    
    const validate = () => {
        const errors = {};
        if (!memberName) errors.memberName = "Please enter a member name.";
        if (!description) errors.description = "Please enter a description.";
        if (!experience) errors.experience = "Please enter an experience.";
        if(!contactnumber) errors.contactnumber="Please enter a contactnumber";
        if(!email) errors.email="Please enter a Email";
        if(!status) errors.status="Please select Status";
        // if (!files.length === 0) errors.files = "Please select one image.";
        setPropertyErrors(errors);
        return Object.keys(errors).length === 0;
      };

    const handleSave = async (event) => {
        debugger
        event.preventDefault();
        if (!validate()) return;
        // Create a new FormData object to hold the form data
        const formData = new FormData();

        formData.append("name", memberName);
        formData.append("description", description);
        formData.append("specialization", experience);
        formData.append("contact_number",contactnumber);
        formData.append("email",email);
        formData.append("status",status);

        // Append the selected image if available
        if (selectedImage) {
            formData.append("image", selectedImage); // Add image file to the form data
        }

        for (let pair of formData.entries()) {
            console.log(pair[0] + ": " + pair[1]);
        }
        setLoading(true);
        try {
            const response = await investorApi.addLegalTeam(formData);
            setSnackbarMessage("Team added successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            resetForm();
            navigate(-1);
        } catch (error) {
            setSnackbarMessage("Failed to add team. Please try again.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
            
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setMemberName("");
        setExperience("");
        setDescription("");
        setPropertyErrors({});
    };

    return (
        <Container sx={{ py: 5, maxWidth: "80%" }}>
            {/* Loader */}
            <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* Snackbar */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
                <Typography variant="h4" component="h1" sx={{ color: "#13216e", fontWeight: 600, fontSize: "24px" }}>
                    Add Team
                </Typography>
                <Box>
                    <Link to="/team" style={{ textDecoration: "none", color: "#4e0dff", fontSize: "18px" }}>
                        Home
                    </Link>
                    <BsArrowRight style={{ margin: "-2px 8px", color: "#4e0dff" }} />
                    <Link to="#" style={{ textDecoration: "none", color: "#4e0dff", fontSize: "18px" }}>
                        Team
                    </Link>
                </Box>
            </Box>

            <Paper elevation={3} sx={{ padding: 3 }}>
                <form onSubmit={handleSave}>
                    <Grid container spacing={3}>

                        <Grid item xs={12}>
                            <TextField
                                label="Member Name"
                                fullWidth
                                value={memberName}
                                onChange={(event) => setMemberName(event.target.value)}
                                error={!!propertyErrors.memberName}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Description"
                                multiline
                                rows={4}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                fullWidth
                                error={!!propertyErrors.description}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="specialization"
                                fullWidth
                                value={experience}
                                onChange={(event) => setExperience(event.target.value)}
                                error={!!propertyErrors.experience}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="ContactNumber"
                                type="number"
                                fullWidth
                                value={contactnumber}
                                onChange={(event) => setContactNumber(event.target.value)}
                                error={!!propertyErrors.experience}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="email"
                                fullWidth
                                value={email}
                                onChange={(event) => setEmail(event.target.value)}
                                error={!!propertyErrors.experience}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel> Status </InputLabel>
                                <Select
                                  value={status}
                                  onChange={(event)=>setStatus(event.target.value)}
                                  label="Status"
                                  error={!!propertyErrors.status}
                                >
                                   {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                        ))}
                  

                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {/* Display Image Section */}
                    <Grid item xs={12} sx={{ mt: 3 }}>
                        <Typography variant="h6" sx={{ color: "#13216e", fontWeight: 600, fontSize: "20px" }}>
                            Profile Picture
                        </Typography>
                        <label htmlFor="display-image-upload" style={{ cursor: "pointer", margin: "10px 15px" }}>
                            <Button
                                variant="outlined"
                                color="primary"
                                component="span"
                                sx={{
                                    borderColor: "primary.main",
                                    color: "#fff",
                                    backgroundColor: "#1565c0",
                                    "&:hover": {
                                        background: "#1565c0",
                                        color: "rgba(25, 118, 210, 0.04)",
                                        borderColor: "#1976d2",
                                    },
                                }}
                            >
                                Choose Display Image
                            </Button>
                        </label>
                        <input
                            id="display-image-upload"
                            type="file"
                            onChange={handleDisplayImageChange}
                            style={{ display: "none" }}
                        />
                        {selectedImage && (
                            <Box sx={{ mt: 2 }}>
                                <img
                                    src={ImagePreview}
                                    alt="Display"
                                    style={{
                                        width: "20%",
                                        height: "20%",
                                        objectFit: "cover",
                                        margin: 5,
                                        borderRadius: 8,
                                    }}
                                />
                            </Box>
                        )}
                    </Grid>

                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                        <Button variant="outlined" color="secondary" onClick={resetForm} sx={{ mr: 2 }}>
                            Reset
                        </Button>
                        <Button type="submit" variant="contained" color="primary">
                            Add
                        </Button>
                    </Box>
                </form>
            </Paper>
        </Container>
    );
};

export default NewTeam;
